<template>
    <div id="sqRoom">
        <top :title="title"></top>
        <div class="setFix"></div>
        <div class="roomBox clearfix" :class="[setover?'more':'']" v-if="userLists.length!=0">
            <div class="item" @click="share()">
                <img src="@/assets/imgs/add1.png" alt="">
                <p class="txt">邀请</p>
            </div>
            <div class="item" v-for="(item,i) in userLists" :key="i" @click="intoPerson(item.openId)">
                <img :src="item.avatar" alt="">
                <p class="txt">{{item.username}}</p>
            </div>
        </div>
        <!-- 无数据 -->
        <div class="noLists" v-show="showSwitch==true && userLists.length==0">
            <img src="~@/assets/imgs/bg.png" alt="">
            <p>这里空空如也~</p>
        </div>
        <p class="lookAll" @click="loadMore()" v-if="userLists.length>=24" :class="isBtm?'isNo':''">查看全部社区邻友</p>
    </div>
</template>

<script>
import axios from 'axios';
import Top from '@/component/top/top'
import {Toast, Indicator} from 'mint-ui'
export default {
    data() {
        return {
            setover:false,
            userLists:[],
            showSwitch:false,
            title:'社区邻友',
            isBtm:false
        }
    },
    components:{
        Top
    },
    created() {
        this.getuserLists(this.$route.query.poiid)
    },
    methods:{
        loadMore() {
            this.setover = true
            this.isBtm = true
        },
        getuserLists(id) {
            Indicator.open()
            axios.get(`${this.commonIp()}/v1/mobile/community/users?poiId=${id}`).then((res) => {
                Indicator.close()
                if(res.data.code == 200) {
                    if(res.data.data.users.length!=0) {
                        this.userLists = res.data.data.users
                        this.showSwitch = false
                    }else{
                        this.showSwitch = true
                    }
                }else{
                    Toast(res.data.message)
                }
            })  
        },
        // 进入个人中心
        intoPerson(id) {
            this.isScreen(`app://userinfo?openId=${id}`)
        },
        share() {
            this.isScreen("app://share")
        }
    }
}
</script>

<style lang="less">
@import '~@/assets/less/index.less';
    #sqRoom{
        .roomBox{
            border-top:1px solid #d8d8d8;
            // height:150px;
            height:430px;
            overflow: hidden;
            &.more{
                overflow:auto;
                height: auto;
            }
            .item{
                .fl();
                height:70px;
                text-align:center;
                width:20%;
                padding:15px 0 0 0;
                img{
                    width:45px;
                    border-radius: 50%;
                    height: 45px;
                }
                .txt{
                    color:@gray;
                    font-size:@ft13;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 75px;
                    margin:0 auto;
                }
            }
        }
        .lookAll{
            margin-top:16px;
            color:@gray;
            font-size:@ft14;
            text-align: center;
            &.isNo{
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/sqroom/sqroom.vue